
const common = {
  // Navigation
  home: 'الرئيسية',
  about: 'من نحن',
  services: 'خدماتنا',
  projects: 'مشاريعنا',
  team: 'فريقنا',
  testimonials: 'آراء العملاء',
  contact: 'اتصل بنا',
  
  // Hero Section
  heroTitle: 'بزل تُبدع بيئات آمنة وملهمة للأطفال',
  heroSubtitle: 'متخصصون في تصميم وتجهيز الحضانات والروضات والمراكز الخاصة والساحات الخارجية',
  
  // Hero Slides
  heroSlide1Title: 'بزل تُبدع بيئات آمنة وملهمة للأطفال',
  heroSlide1Subtitle: 'متخصصون في تصميم وتجهيز الحضانات والروضات والمراكز الخاصة والساحات الخارجية',
  heroSlide2Title: 'تصميم ثلاثي الأبعاد لمشروعك',
  heroSlide2Subtitle: 'شاهد مشروعك بشكل واقعي قبل التنفيذ - نقدم عروض 3D احترافية توضح كل التفاصيل',
  
  viewProjects: 'مشاريعنا',
  freeConsultation: 'استشارة وتقييم',
  
  // About Section
  aboutTitle: 'نبذة عن بزل',
  aboutDescription: 'بزل هي علامة سعودية رائدة متخصصة في تصميم وتنفيذ البيئات التعليمية والترفيهية الآمنة والملهمة للأطفال. نحن نؤمن بأن كل طفل يستحق بيئة تحفز إبداعه وتنمي مهاراته.',
  
  // Specializations
  specializationsTitle: 'مجالات تخصصنا',
  nurserySetup: 'تجهيز الحضانات',
  kindergartenSetup: 'تجهيز الروضات',
  specialCenters: 'المراكز الخاصة',
  playrooms: 'مناطق الألعاب',
  outdoorAreas: 'الساحات الخارجية',
  
  // Services
  servicesTitle: 'خدماتنا',
  service1Title: 'تصميم ثلاثي الأبعاد للمشاريع',
  service1Description: 'عرض واقعي 3D يوضح شكل المشروع قبل التنفيذ للحضانات والمراكز والساحات',
  service2Title: 'تجهيز الحضانات والروضات',
  service2Description: 'تنفيذ شامل للأثاث والألعاب والديكور الآمن مع مراعاة معايير الجودة',
  service3Title: 'تجهيز المراكز الخاصة',
  service3Description: 'تصميم وتنفيذ غرف علاج وظيفي وحسية مزودة بألعاب تعليمية تفاعلية',
  service4Title: 'تجهيز مناطق ألعاب الأطفال',
  service4Description: 'تصميم بيئات داخلية منزلية وتعليمية تفاعلية',
  service5Title: 'تجهيز الساحات والمراكز الترفيهية',
  service5Description: 'تنفيذ مناطق لعب خارجية آمنة ومجهزة بالأرضيات المطاطية',
  
  // Social Responsibility
  socialResponsibilityTitle: 'مسؤوليتنا الاجتماعية',
  socialResponsibilitySubtitle: 'نؤمن بدورنا في خدمة المجتمع وتطوير البيئة التعليمية للأطفال في جميع أنحاء المملكة',
  charityNurseries: 'مبادرة بزل للحضانات الخيرية',
  charityNurseriesDesc: 'نقدم خدمات التجهيز والتصميم مجاناً للحضانات الخيرية لدعم الأطفال المحتاجين',
  professionalTraining: 'برنامج التدريب المهني',
  professionalTrainingDesc: 'نوفر برامج تدريبية مجانية للشباب السعودي في مجال تصميم البيئات التعليمية',
  knowledgeSharing: 'مشاركة المعرفة',
  knowledgeSharingDesc: 'ننظم ورش عمل ومحاضرات توعوية للمختصين في مجال رعاية الطفولة المبكرة',
  environmentalSustainability: 'الاستدامة البيئية',
  environmentalSustainabilityDesc: 'نلتزم باستخدام مواد صديقة للبيئة وتقنيات موفرة للطاقة في جميع مشاريعنا',
  
  // Projects
  projectsTitle: 'مشاريعنا',
  beforeAfter: 'شاهد التحول المذهل في مشاريعنا - قبل وبعد',
  projectsSubtitle: 'من مساحات عادية إلى بيئات مُلهمة تُحفّز الإبداع والتعلم',
  
  // Team
  teamTitle: 'فريق بزل',
  teamDescription: 'فريق متخصص من المصممين والمهندسين والمنفذين يعمل بروح الإبداع والتعاون',
  teamMember1Name: 'أحمد محمد الأحمد',
  teamMember1Position: 'المدير التنفيذي ومؤسس الشركة',
  teamMember1Bio: 'خبرة 15 عاماً في تصميم البيئات التعليمية والترفيهية للأطفال',
  teamMember2Name: 'فاطمة سالم العتيبي',
  teamMember2Position: 'مديرة التصميم الداخلي',
  teamMember2Bio: 'متخصصة في التصميم الداخلي للحضانات والمراكز التعليمية',
  teamMember3Name: 'خالد عبدالله النعيمي',
  teamMember3Position: 'مهندس التنفيذ والإشراف',
  teamMember3Bio: 'مهندس مدني متخصص في تنفيذ المشاريع التعليمية والترفيهية',
  teamMember4Name: 'نورا أحمد الزهراني',
  teamMember4Position: 'أخصائية علم نفس الطفل',
  teamMember4Bio: 'خبيرة في تصميم البيئات التعليمية المناسبة لنمو الطفل',
  
  // Testimonials
  testimonialsTitle: 'آراء عملائنا',
  testimonialsSubtitle: 'ما يقوله عملاؤنا عن خدماتنا وجودة عملنا',
  testimonial1Text: 'بزل حولت حضانتنا إلى مكان رائع ومحفز للأطفال. التصميم والتنفيذ كان أكثر من ممتاز والأطفال يحبون المكان الجديد.',
  testimonial1Name: 'سارة أحمد',
  testimonial1Position: 'مديرة حضانة براعم المستقبل',
  testimonial2Text: 'العمل مع فريق بزل كان تجربة رائعة. اهتمامهم بالتفاصيل والجودة العالية جعل مركزنا الخاص مكاناً مثالياً للأطفال ذوي الاحتياجات الخاصة.',
  testimonial2Name: 'محمد الغامدي',
  testimonial2Position: 'مدير مركز النور للتأهيل',
  testimonial3Text: 'تصميم الساحة الخارجية لمدرستنا كان إبداعياً ومبتكراً. الأطفال يستمتعون باللعب في بيئة آمنة وجميلة.',
  testimonial3Name: 'هند العتيبي',
  testimonial3Position: 'مديرة مدرسة الأمل الابتدائية',
  
  // Contact
  contactTitle: 'تواصل معنا',
  contactSubtitle: 'نحن هنا لمساعدتك في تحقيق رؤيتك لبيئة تعليمية وترفيهية مثالية',
  name: 'الاسم',
  organization: 'اسم الجهة / المؤسسة',
  phone: 'رقم الجوال',
  email: 'البريد الإلكتروني',
  projectType: 'نوع المشروع',
  city: 'المنطقة / المدينة',
  country: 'الدولة',
  clientType: 'نوع العميل',
  individual: 'فردي',
  companyOrg: 'مؤسسة / شركة',
  message: 'الرسالة',
  send: 'إرسال',
  contactInfo: 'معلومات التواصل',
  address: 'العنوان',
  addressValue: 'الرياض، المملكة العربية السعودية',
  phoneValue: '+966 50 123 4567',
  emailValue: 'info@puzzle-sa.com',
  workingHours: 'ساعات العمل',
  workingHoursValue: 'الأحد - الخميس: 8:00 ص - 6:00 م',
  
  // Footer
  footerDescription: 'بزل السعودية الرائدة في تصميم وتنفيذ البيئات التعليمية والترفيهية الآمنة والملهمة للأطفال',
  quickLinks: 'روابط سريعة',
  privacyPolicy: 'سياسة الخصوصية',
  followUs: 'تابعنا',
  allRightsReserved: 'جميع الحقوق محفوظة',
  
  // Common Actions
  learnMore: 'اعرف المزيد',
  serviceDetails: 'تفاصيل الخدمة',
  getQuote: 'طلب عرض سعر',
  viewAll: 'عرض الكل',
  readMore: 'اقرأ المزيد',
  
  // Form placeholders
  namePlaceholder: 'أدخل اسمك الكامل',
  organizationPlaceholder: 'أدخل اسم المؤسسة أو الشركة',
  phonePlaceholder: 'رقم الجوال',
  emailPlaceholder: 'البريد الإلكتروني',
  messagePlaceholder: 'اكتب رسالتك هنا...',
  
  // Project types
  nursery: 'حضانة أو روضة',
  specialCenter: 'مركز خاص',
  playroom: 'منطقة ألعاب',
  gameRoom: 'غرفة ألعاب',
  outdoorArea: 'ساحة خارجية',
  other: 'أخرى',
  
  // Budget
  budgetRange: 'نطاق الميزانية المتوقعة',

  // Locations
  selectCountry: 'اختر الدولة',
  searchCountry: 'ابحث عن الدولة...',
  selectCity: 'اختر المنطقة / المدينة',
  searchCity: 'ابحث عن المنطقة...',
  loadingLocations: 'جارٍ تحميل البيانات...',
  noResultsFound: 'لا توجد نتائج',
  selectCountryFirst: 'اختر الدولة أولاً',
  
  // API Error Messages
  apiRequestFailed: 'فشل طلب API',
  connectionError: 'خطأ في الاتصال بالسيرفر',
  serverError: 'حدث خطأ في السيرفر',
  
  // Form Messages
  formSuccessMessage: 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.',
  formErrorMessage: 'حدث خطأ في إرسال الرسالة. يرجى المحاولة مرة أخرى.',
  sending: 'جاري الإرسال...',
  sendUsMessage: 'أرسل لنا رسالة',
  sendUsMessageDescription: 'نحن هنا لمساعدتك. املأ النموذج وسنتواصل معك قريباً.',
  formConsentPrefix: 'بإرسال النموذج فإنك توافق على',
  formConsentLink: 'سياسة الخصوصية واتفاقية الاستخدام',
  invalidSaudiPhone: 'يرجى إدخال رقم جوال سعودي صحيح',
  invalidEmail: 'يرجى إدخال بريد إلكتروني صحيح',
  
  // Success Page
  successPageTitle: '🎉 شكراً لتواصلك معنا!',
  successPageSubtitle: 'تم استلام رسالتك بنجاح',
  successPageDescription: 'سيقوم فريقنا بمراجعة طلبك والتواصل معك خلال 24 ساعة',
  successPageCallUs: 'أو اتصل بنا الآن على الرقم الموحد',
  successPageFollowUs: 'تابعنا على وسائل التواصل الاجتماعي',
  successPageBackHome: 'العودة للرئيسية',
  successPageViewProjects: 'تصفح مشاريعنا',
  successPageThankYou: 'نقدر ثقتكم بنا ونتطلع للعمل معكم لإنشاء بيئة آمنة وملهمة لأطفالكم',
  
  // Services Page
  ourMainServices: 'خدماتنا الرئيسية',
  workProcess: 'مراحل العمل',
  workProcessDescription: 'نتبع منهجية واضحة ومنظمة لضمان تنفيذ مشروعكم بأعلى جودة',
  comprehensiveSolutions: 'حلول شاملة ومتكاملة لتصميم وتنفيذ البيئات التعليمية والترفيهية',
  readyToStart: 'هل أنت مستعد لبدء مشروعك؟',
  contactForQuote: 'تواصل معنا اليوم للحصول على استشارة وتقييم وعرض سعر مخصص لمشروعك',
  viewOurProjects: 'شاهد مشاريعنا',
  
  // Linktree Page
  followOnAllPlatforms: 'تابعنا على جميع المنصات',
  shopNow: 'اشتري الآن',
  technicalSupport: 'الدعم الفني',
  salesTeam: 'قسم المبيعات',
  supportPhone: 'هاتف الدعم',
  salesPhones: 'أرقام المبيعات',
  
  // Image Modal
  imageModalHint: 'اضغط في أي مكان أو ESC للإغلاق',

  // Playroom Landing Page
  playroomLandingTitle: 'مناطق الألعاب المثالية لأطفالك',
  playroomLandingSubtitle: 'نحوّل أي مساحة إلى عالم خيال آمن ومحفّز',
  playroomLandingHeroDesc: 'تصميم احترافي وتنفيذ متكامل لمناطق ألعاب الأطفال — من الفكرة إلى الواقع بضمان الجودة والسلامة.',
  playroomLandingCTA: 'احصل على استشارة وتقييم',
  playroomLandingFormTitle: 'طلب عرض سعر مجاني',
  playroomLandingFormDesc: 'أخبرنا عن مساحتك وسنبدأ بتصميم حلم طفلك.',
  playroomLandingBeforeAfterTitle: 'قبل وبعد — شاهد التحوّل',
  playroomLandingBeforeAfterSubtitle: 'مشاريع حقيقية نفّذها فريق بزل في منازل ومراكز بالمملكة',
  playroomLandingBefore: 'قبل',
  playroomLandingAfter: 'بعد',
  playroomLandingWhyUs: 'لماذا بزل؟',
  playroomLandingWhyUsSubtitle: 'خبرة تتحدث بالنتائج',
  playroomLandingFeat1Title: 'تصميم ثلاثي الأبعاد',
  playroomLandingFeat1Desc: 'شاهد منطقة ألعاب طفلك قبل التنفيذ بتصاميم واقعية',
  playroomLandingFeat2Title: 'مواد آمنة معتمدة',
  playroomLandingFeat2Desc: 'نستخدم مواد صديقة للأطفال وخالية من المواد الضارة',
  playroomLandingFeat3Title: 'تنفيذ متكامل',
  playroomLandingFeat3Desc: 'من الديكور إلى الألعاب والأثاث — كل شيء في يدٍ واحدة',
  playroomLandingFeat4Title: 'ضمان ما بعد التسليم',
  playroomLandingFeat4Desc: 'دعم ومتابعة مستمرة بعد تسليم مشروعك',
  playroomLandingCallout: 'ابدأ تحويل مساحتك اليوم',
  playroomLandingCalloutCTA: 'تواصل معنا الآن',
  playroomLandingProjectsTitle: 'من أعمالنا في غرف الألعاب',
  playroomLandingProjectsSubtitle: 'كل مشروع هو قصة نجاح جديدة',
  playroomLandingStep1: 'استشارة وتقييم',
  playroomLandingStep1Desc: 'نسمع فكرتك ونقيّم المساحة',
  playroomLandingStep2: 'تصميم مخصص',
  playroomLandingStep2Desc: 'نصمم بالـ 3D حسب مساحتك وميزانيتك',
  playroomLandingStep3: 'تنفيذ احترافي',
  playroomLandingStep3Desc: 'فريقنا يُنفّذ بدقة وفي الوقت المحدد',
  playroomLandingStep4: 'التسليم والمتابعة',
  playroomLandingStep4Desc: 'نسلّم المشروع ونتابع رضاك',

  // Play Areas Service Details Page
  playAreasPageSeoTitle: 'بزل - خدمة تجهيز مناطق الألعاب',
  playAreasPageSeoDescription: 'صفحة تفصيلية لخدمة تجهيز مناطق الألعاب من بزل: تصميم ثلاثي الأبعاد، تنفيذ آمن، خامات معتمدة، وتجهيز متكامل للمساحات الداخلية والخارجية.',
  playAreasPageSeoKeywords: 'تجهيز مناطق ألعاب، تصميم مناطق ألعاب أطفال، ألعاب داخلية وخارجية، بزل السعودية',
  playAreasPageTag: 'خدمة تفصيلية',
  playAreasPageTitle: 'خدمة تجهيز مناطق الألعاب',
  playAreasPageHeroSubtitle: 'حلول متكاملة للمناطق الداخلية والخارجية بمعايير أمان عالية',
  playAreasPageHeroDescription: 'نصمم وننفذ مناطق ألعاب عملية وجذابة تناسب الفئة العمرية المستهدفة وتدعم تجربة لعب آمنة وممتعة.',
  playAreasPagePrimaryCta: 'ابدأ مشروعك معنا',
  playAreasPageSecondaryCta: 'شاهد مشاريع مشابهة',
  playAreasPageHighlightsTitle: 'ماذا نقدم في هذه الخدمة؟',
  playAreasPageHighlightsSubtitle: 'من الفكرة إلى التسليم مع متابعة دقيقة في كل مرحلة',
  playAreasPageHighlight1Title: 'تصميم ثلاثي الأبعاد قبل التنفيذ',
  playAreasPageHighlight1Desc: 'نقدّم تصوراً واضحاً للمساحة قبل بدء التنفيذ لتسريع اتخاذ القرار.',
  playAreasPageHighlight2Title: 'سلامة وجودة معتمدة',
  playAreasPageHighlight2Desc: 'اختيار خامات وألعاب مناسبة للأطفال وتطبيق اشتراطات السلامة.',
  playAreasPageHighlight3Title: 'تنفيذ وتركيب احترافي',
  playAreasPageHighlight3Desc: 'فريق متخصص في تجهيز الأرضيات والألعاب والأثاث بدقة عالية.',
  playAreasPageHighlight4Title: 'حلول تناسب ميزانيتك',
  playAreasPageHighlight4Desc: 'نقترح خيارات مرنة تحقق أفضل نتيجة ضمن الميزانية المتاحة.',
  playAreasPageProjectsTitle: 'نماذج من مناطق الألعاب',
  playAreasPageProjectsSubtitle: 'أعمال حقيقية نفذها فريق بزل في مواقع متعددة',
  playAreasPageProcessTitle: 'آلية العمل',
  playAreasPageProcessSubtitle: '4 خطوات واضحة للوصول إلى نتيجة مثالية',
  playAreasPageStep1Title: 'تحليل الموقع والاحتياج',
  playAreasPageStep1Desc: 'فهم المساحة، الفئة العمرية، وأهداف المشروع.',
  playAreasPageStep2Title: 'التصميم واعتماد المقترح',
  playAreasPageStep2Desc: 'إعداد تصور 3D وخيارات مناسبة قبل اعتماد النسخة النهائية.',
  playAreasPageStep3Title: 'التجهيز والتنفيذ',
  playAreasPageStep3Desc: 'تنفيذ الأعمال وفق جدول واضح مع متابعة الجودة.',
  playAreasPageStep4Title: 'التسليم والمتابعة',
  playAreasPageStep4Desc: 'تسليم المشروع جاهزاً للاستخدام مع دعم بعد التنفيذ.',
  playAreasPageFinalTitle: 'جاهز لتحويل مساحتك إلى منطقة ألعاب مميزة؟',
  playAreasPageFinalDesc: 'تواصل مع فريق بزل الآن للحصول على استشارة وتقييم وعرض سعر مناسب.'
};

export default common;
